var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 5,
    fill: "#FBF1DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4112 7.67486L36.3767 15.5082M17.4321 22.1574H30.4446M17.4321 31.6452H30.4446M17.4321 26.9013H30.4446M13.0552 7.67486C12.6392 7.68491 12.2436 7.85453 11.953 8.1475C11.6625 8.44046 11.4999 8.83354 11.5 9.24279V36.7657C11.5001 37.1748 11.6626 37.5676 11.953 37.8605C12.2434 38.1534 12.6386 38.3232 13.0544 38.3337H34.8223C35.2451 38.3337 35.6507 38.1685 35.9497 37.8744C36.2487 37.5804 36.4167 37.1816 36.4167 36.7657V15.5082H30.0384C29.6223 15.498 29.2267 15.3282 28.9362 15.0351C28.6456 14.742 28.4831 14.3488 28.4832 13.9395V7.66699L13.0552 7.67486Z",
    stroke: "#FFAF04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.7d988b86f621eec83526821fdea17421.svg";
export { ForwardRef as ReactComponent };